import axios, { AxiosError, AxiosResponse } from 'libs/axios';
import { useMutation, useQuery } from 'react-query';
import { Log, LogDetailedData, ValidationResponse } from 'types/log';
import { LOG_QUERY_KEY } from './query-keys';

export const useDeleteLogs = () => {
    return useMutation<AxiosResponse<string>, AxiosError, Log[]>(
        async (logs: Log[]) =>
            axios.post<string>(
                `/api/ui/timelinelogs/deletion`,
                logs.map((log) => log.id)
            )
    );
};

interface UploadLogsData {
    logsList: string[];
    projectName: string;
    projectId: number;
}

export const useUploadLogs = () => {
    return useMutation<string, AxiosError, UploadLogsData>(
        async (data: UploadLogsData) => {
            const response = await axios.post<string>(`/api/ui/upload`, data);

            return response.data;
        }
    );
};

export const useValidateUpload = () => {
    return useMutation<ValidationResponse, AxiosError, Log[]>(async (logs) => {
        const response = await axios.post<ValidationResponse>(
            `/api/ui/upload/validate`,
            logs.map((log) => log.id)
        );

        return response.data;
    });
};

interface GetLog {
    id: string;
    page: number;
    pageSize: number;
    waitForForms?: boolean;
}

export const useGetLog = ({ id, page, pageSize, waitForForms }: GetLog) => {
    return useQuery<LogDetailedData, AxiosError>(
        [LOG_QUERY_KEY, { id, page, pageSize, waitForForms }],
        async () => {
            const response = await axios.get<LogDetailedData>(
                `/api/ui/timelinelogs/${id}`,
                {
                    params: {
                        page,
                        pageSize,
                        waitForForms
                    }
                }
            );

            return response.data;
        },
        {
            keepPreviousData: true,
            cacheTime: 0
        }
    );
};
